<template>
  <b-container fluid>
    <b-row style="height: 100vh">
      <b-col class="rdcolors login-left">
        <img
          style="width: 10.8rem; height: 2.4rem"
          src="../assets/images/logo.png"
          alt="readycash logo"
        />
      </b-col>
      <b-col class="login-right">
        <b-row style="width: 100%">
          <b-col offset="2" cols="8">
            <h4 style="font-weight: 700" class="pb-2">
              Become a
              <span style="color: var(--primary); display: block"
                >ReadyCash Aggregator Today</span
              >
            </h4>
            <p style="color: var(--gray-400); font-size: 1.125rem" class="pb-3">
              Enter your details to create your account
            </p>
            <div class="invalid-feedback d-block">
              {{ error }}
              <span class="text-success">{{ success }}</span>
            </div>
            <b-form @submit.prevent="submit">
              <div class="pb-3">
                <label>Agent ID</label>
                <b-form-input
                  :class="{ 'is-invalid': $v.agentId.$error }"
                  type="text"
                  placeholder="Enter agent id"
                  v-model.trim="$v.agentId.$model"
                  trim
                />
                <div class="invalid-feedback">
                  {{ $v.agentId.$error ? "AgentId is required" : "" }}
                </div>
              </div>
              <div class="pb-3">
                <label>Email Address</label>
                <b-form-input
                  :class="{ 'is-invalid': $v.email.$error }"
                  type="email"
                  placeholder="Enter email address"
                  v-model.trim="$v.email.$model"
                  trim
                />
                <div class="invalid-feedback">
                  {{ $v.email.$error ? "Please enter a valid email" : "" }}
                </div>
              </div>

              <div class="pb-3">
                <label>Password</label>
                <b-form-input
                  :class="{ 'is-invalid': $v.password.$error }"
                  :type="inputType"
                  placeholder="Enter Password"
                  v-model.trim="$v.password.$model"
                  trim
                />
                <img
                  class="eye"
                  :class="{
                    'eye-mt': inputType == 'text',
                  }"
                  :src="require('./../assets/icons/eye-' + eyeState + '.svg')"
                  alt="Hidden"
                  @click="toggleEyeState"
                />
                <div class="validations">
                  <span :class="{ 'text-success': $v.password.required }">
                    <img
                      v-if="$v.password.required"
                      src="./../assets/icons/check.svg"
                      alt="Passed"
                    />
                    {{ errorMessages.required }}
                  </span>
                  <span
                    :class="{
                      'text-success': $v.password.$model.length >= 8,
                    }"
                  >
                    <img
                      v-if="$v.password.$model.length >= 8"
                      src="./../assets/icons/check.svg"
                      alt="Passed"
                    />
                    {{ errorMessages.minLength }}
                  </span>
                  <span :class="{ 'text-success': $v.password.upperCaseCheck }">
                    <img
                      v-if="$v.password.upperCaseCheck"
                      src="./../assets/icons/check.svg"
                      alt="Passed"
                    />
                    {{ errorMessages.upperCaseCheck }}
                  </span>
                  <span :class="{ 'text-success': $v.password.numberCheck }">
                    <img
                      v-if="$v.password.numberCheck"
                      src="./../assets/icons/check.svg"
                      alt="Passed"
                    />
                    {{ errorMessages.numberCheck }}
                  </span>
                  <span
                    :class="{ 'text-success': $v.password.specialCharCheck }"
                  >
                    <img
                      v-if="$v.password.specialCharCheck"
                      src="./../assets/icons/check.svg"
                      alt="Passed"
                    />
                    {{ errorMessages.specialCharCheck }}
                  </span>
                </div>
              </div>

              <div style="padding-top: 2rem">
                <b-button
                  :disabled="user.loading || $v.password.$invalid"
                  type="submit"
                  block
                  variant="primary"
                  >{{ user.loading ? "Loading..." : "Signup" }}
                </b-button>
              </div>
            </b-form>
            <p
              style="
                padding-top: 2rem;
                color: var(--gray-600);
                text-align: center;
              "
            >
              Already an aggregator?<router-link
                style="font-weight: 600"
                to="/"
              >
                Login now</router-link
              >
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
export default {
  name: "Signup",
  data() {
    return {
      agentId: "",
      email: "",
      password: "",
    };
  },
  validations: {
    agentId: {
      required,
    },
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(8),
      upperCaseCheck(password) {
        return /[A-Z]/.test(password) && /[a-z]/.test(password); // checks for a-z
      },
      numberCheck(password) {
        return /[0-9]/.test(password); // checks for 0-9
      },
      specialCharCheck(password) {
        return /\W|_^\S*$/.test(password); // checks for special char
      },
    },
  },
  methods: {
    ...mapActions({
      signup: "user/signup",
    }),
    toggleEyeState() {
      this.$store.dispatch("toggleEyeState");
    },
    submit() {
      this.$store.state.eye.inputType = "password";
      this.$store.state.eye.eyeState = "hidden";
      this.$store.state.user.error = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.signup({
          agentId: this.$data.agentId,
          email: this.$data.email,
          password: this.$data.password,
        }).then(() =>
          this.user.token ? this.$router.replace("dashboard") : null
        );
      }
    },
  },
  computed: mapState({
    user: (state) => state.user,
    success: (state) => state.user.success,
    error: (state) => state.user.error,
    errorMessages: (state) => state.user.errorMessages,
    inputType: (state) => state.eye.inputType,
    eyeState: (state) => state.eye.eyeState,
  }),
  created() {
    document.title = "Sign Up | ReadyCash Aggregator Portal";
  },
  destroyed() {
    this.$store.state.user.error = null;
    this.$store.state.user.success = null;
    this.$store.state.user.status = null;
  },
};
</script>

<style lang="scss">
.login-left {
  padding: 1.5rem;
  background: hsl(0, 100%, 98%);
}
.login-right {
  padding: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.eye-mt {
  margin-top: -2.1rem;
  width: 3.73rem;
}
</style>
